import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import DatePickerForm from 'components/molecules/DatePickerForm';
import FormField from 'components/atoms/Form/FormField';
import TextForm from 'components/molecules/TextForm';
import VerticalLabelSelectForm from 'components/molecules/VerticalLabelSelectForm';
import FormSubmitArea from 'components/atoms/Form/FormSubmitArea';
import PrimaryButton from 'components/atoms/Button';
import BlockUI from 'components/molecules/BlockUi';
import ConfirmActionModal, { ActionType } from 'components/organismos/ConfirmActionModal';
import FormContents from 'components/atoms/Form/FormContents';
import FlexBox from 'components/atoms/FlexBox';
import FlexBoxItem from 'components/atoms/FlexBoxItem';
import Checkbox from 'components/molecules/Checkbox';
import { css } from '@emotion/core';
import { useSalesExpenseForm } from './hook';
import { useSelector } from 'react-redux';
import { Store } from 'modules/store';

const SalesExpensesInputForm: React.FC<{}> = () => {
  const {
    blocking,
    expensesCode,
    setExpensesCode,
    expensesName,
    setExpensesName,
    dispOrder,
    setDispOrder,
    expensesClassification,
    setExpensesClassification,
    undecided,
    setUndecided,
    applyStartDate,
    setApplyStartDate,
    applyEndDate,
    setApplyEndDate,
    expensesCodeId,
    confirmModalOpen,
    closeConfirmModal,
    openConfirmModal,
    handleSubmit,
  } = useSalesExpenseForm();

  const roleScreen = useSelector((state: Store) => state.auth.roleScreen);

  return (
    <BlockUI blocking={blocking}>
      <FormContents>
        <p>
          {`${!expensesCodeId ? 'その他経費の項目を登録します。コード、名称、並び順の他、区分（固定費/変動費）、適用開始日を入力してください。' : ''}`}
        </p>
        <FormField>
          <TextForm
            name="expensesCode"
            label="コード"
            value={expensesCode}
            required={true}
            disable={!!expensesCodeId}
            onChange={
              (e) => { setExpensesCode(e.target.value); }
            }
          />
        </FormField>
        <FormField>
          <TextForm
            name="expensesName"
            label="名称"
            value={expensesName}
            required={true}
            onChange={
              (e) => { setExpensesName(e.target.value); }
            }
          />
        </FormField>
        <FormField>
          <TextForm
            type="number"
            name="dispOrder"
            label="並び順"
            value={String(dispOrder)}
            required={true}
            onChange={
              (e) => { setDispOrder(Number(e.target.value)); }
            }
          />
        </FormField>
        <FormField>
          <VerticalLabelSelectForm
            label="経費区分"
            name="expensesClassification"
            value={String(expensesClassification)}
            setValue={(v: string) => {
              setExpensesClassification(v);
            }}
            required={true}
            options={[{ value: '0', label: '変動費' }, { value: '1', label: '固定費' }]}
          />
        </FormField>
        <FormField>
          <DatePickerForm
            required={true}
            dateFormat="yyyy年MM月"
            label="適用開始月"
            isFullWidth={true}
            date={applyStartDate}
            showMonthYearPicker={true}
            changeDate={(date: Date) => {
              if (date !== null) {
                setApplyStartDate(date);
              }
            }}
          />
        </FormField>
        <FormField>
          <FlexBox>
            <FlexBoxItem>
              <DatePickerForm
                dateFormat="yyyy年MM月"
                label="適用終了月"
                isFullWidth={true}
                date={applyEndDate}
                disable={undecided}
                showMonthYearPicker={true}
                changeDate={(date: Date) => {
                  if (date !== null) {
                    setApplyEndDate(date);
                  }
                }}
              />
            </FlexBoxItem>
            <FlexBoxItem customStyle={css({ paddingTop: '15px', marginLeft: '15px' })}>
              <Checkbox
                id="undecided"
                name="undecided"
                value=""
                label="未定"
                checked={undecided}
                onChange={(e) => {
                  setUndecided(!undecided);
                  if (e.target.checked) {
                    setApplyEndDate(undefined);
                  } else {
                    setApplyEndDate(new Date());
                  }
                }}
              />
            </FlexBoxItem>
          </FlexBox>
        </FormField>
        <FormSubmitArea>
          {
            roleScreen && roleScreen.editable === 1 && (
              <div style={{ marginRight: '12px' }}>
                <PrimaryButton
                  text={`${expensesCodeId ? '更新' : '登録'}`}
                  onClick={openConfirmModal}
                />
              </div>
            )
          }
          <Link to="/salesExpensesMST">
            <PrimaryButton text="戻る" ghost={true} />
          </Link>
        </FormSubmitArea>

        <ConfirmActionModal
          open={confirmModalOpen}
          closeHandler={closeConfirmModal}
          onSubmit={() => handleSubmit()}
          actionType={expensesCodeId ? ActionType.UPDATE : ActionType.CREATE}
        />
      </FormContents>
    </BlockUI>
  );
};

export default SalesExpensesInputForm;
